import { render, staticRenderFns } from "./delete-button.vue?vue&type=template&id=99c50056&"
import script from "./delete-button.vue?vue&type=script&lang=js&"
export * from "./delete-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports